import { render, staticRenderFns } from "./MediaRules.vue?vue&type=template&id=6f0708c4&scoped=true"
import script from "./MediaRules.vue?vue&type=script&lang=ts"
export * from "./MediaRules.vue?vue&type=script&lang=ts"
import style0 from "./MediaRules.vue?vue&type=style&index=0&id=6f0708c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0708c4",
  null
  
)

export default component.exports